import Vue from 'vue';

import GifPreview from './gif-preview/gif-preview.vue';
import MediaPicture from './media/media-picture.vue';
import MediaImage from './media-image/media-image.vue';
import MediasearchImage from './media-search/media-searchimage.vue';
import MediaItem from './media-item/media-item.vue';
import VideoPlaceholder from './video-placeholder/video-placeholder.vue';
import VideoPlayer from './video-player/video-player.vue';
import Sampler from './sampler/sampler.vue';

Vue.component(GifPreview.name, GifPreview);
Vue.component(MediaImage.name, MediaImage);
Vue.component(MediaPicture.name, MediaPicture);
Vue.component(MediaItem.name, MediaItem);
Vue.component(VideoPlaceholder.name, VideoPlaceholder);
Vue.component(VideoPlayer.name, VideoPlayer);
Vue.component(Sampler.name, Sampler);
Vue.component(MediasearchImage.name, MediasearchImage);
